<template>
 
       <fragment>             
                               
                                <th>Fnactest</th>
                                <th>Fnacdate</th>
                                <th>Fnacres</th>
                            
                              
        </fragment>                     
                    
                  
</template>

<script>



export default {
  name: 'Header',
  data () {
    return {
    }
  },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
    
     
</style>
